/**
 * Функция обертка для GTM dataLayer
 * Создаем глобальную обертку для пуша ДатаЛеер событий.
 * sendToDataLayer, если например даталейр еще не готов,
 * то положим задания в очередь, для исполнения по готовности.
 * так как даталеер, уже содержитьс в window, мы можем с ним работать напрямую.
 */

/** очередь для хранения событий , если dataLayer не готов **/
const pendingDataLayerEvents = [];

/** флаг готовности dataLayer **/
let isDataLayerReady = false;

/**
 * Проверка и инициализация dataLayer с отложенной отправкой событий
 * @param {Function} onSuccess
 * @param {Function} onFalse
 * @param {number} maxAttempts
 * @param {number} intervalMs
 */
export function initDataLayer(
    onSuccess = () => {}, onFalse = () => {},
    maxAttempts = 10, intervalMs = 300
) {
    let attempts = 0;

    window.sendToDataLayer = sendToDataLayer;
    // делаем доступной глобально. чтобы вызывать можно было без window
    eval(`var sendToDataLayer = window.sendToDataLayer`);

    const tryInit = () => {
        attempts++;

        if (Array.isArray(window.dataLayer)) {
            isDataLayerReady = true;

            // Выполнить все отложенные события
            while (pendingDataLayerEvents.length > 0) {
                const event = pendingDataLayerEvents.shift();
                window.dataLayer.push(event);
                console.log('[GTM] Отложенное событие отправлено:', event);
            }

            onSuccess();
        } else if (attempts < maxAttempts) {
            setTimeout(tryInit, intervalMs);
        } else {
            console.warn('[GTM] Не удалось инициализировать dataLayer после', attempts, 'попыток');
            onFalse();
        }
    };

    tryInit();
}

/**
 * Универсальный вызов push в dataLayer
 * Если dataLayer не готов — событие будет отложено
 * @param {Object} eventObject
 */
export function sendToDataLayer(eventObject = {}) {
    
    try {
        if (isDataLayerReady && Array.isArray(window.dataLayer)) {
            window.dataLayer.push(eventObject);
            console.log('[GTM] Событие отправлено:', eventObject);
        } else {
            pendingDataLayerEvents.push(eventObject);
            console.log('[GTM] Событие отложено (dataLayer не готов):', eventObject);
        }
    } catch (e) {
        console.error('[GTM] Ошибка при отправке события в dataLayer:', eventObject, e);
    }
}
